module.exports = __webpack_public_path__ + "img/yuliangr.183c386a.png";